export default __webpack_public_path__ + "static/media/rnr-sports-table-2.b35d3f14.webp";